import React from 'react'
import { Grid, Typography } from '@mui/material'

export default function SubFooter() {
  return (
    <Grid
      container
      sx={{
        background: '#DCDCDC',
        bottom: 0,
        width: '100%',
      }}
    >
      <Grid item xs={12}>
        <Typography
          style={{
            textAlign: 'center',
            marginTop: '20px',
            marginBottom: '20px',
            fontWeight: 'bold',
            fontSize: '14px',
          }}
        >
          Copyright <span style={{ color: 'red' }}>MCASH</span> All Right
          Reserved 2021
        </Typography>
      </Grid>
    </Grid>
  )
}
